import Vue from 'vue'
import App from './App'
import "../../common/css/reset.css";
import $ from "zepto";

import Vconsole from 'vconsole';
if (process.env.NODE_ENV !== 'production') {
  // 测试环境和开发加上vconsole
  let vconsole = new Vconsole()
}

import { Lazyload } from 'vant';
Vue.use(Lazyload);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/module/active_26423/active_26423.js